import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'
import MenuPointer from '../../svg-icons/MenuPointer'

const CustomMenuPointer = styled(MenuPointer)`
  position: absolute;
  top: -12px;
  right: 10px;
  width: 25px;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: none;
  }
`

const CustomLink = styled.div` 
  text-decoration: none;
  ${Fonts.style.Text};
  color: ${props => (props.active ? Colors.primary : Colors.black)};
  font-weight: ${Fonts.weight.light};
  display: ${props =>
    props.mobile || props.subLink ? 'block' : 'inline-block'};
  margin-top:${Metrics.margins.tiny};
  padding: ${Metrics.margins.tiny} 0;
  &.active, hover {
    color: ${Colors.primary};
  }

  &:hover {
    color: ${Colors.primary};u
  }

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: block;
  }
`
const LinkComponent = styled.div`
  cursor: pointer;
  display: inline-block;
  position: relative
  margin-top: ${props => (props.logout ? Metrics.margins.larger : 0)};
  margin-left: ${props => (props.logout ? Metrics.margins.larger : 0)};

  &:hover {
    color: ${Colors.primary};
  }

  &.active {
    color: ${Colors.primary};
  }
`

const Container = styled.div`
  position: relative;
  display: inline-block;
  margin-right: ${Metrics.margins.large};
  ${Fonts.style.Label};
  color: ${props => (props.active ? Colors.primary : Colors.black)};
  font-weight: ${Fonts.weight.normal};

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: block;
    margin-right: 0;
  }
`

const DropdownBox = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  padding: ${Metrics.margins.medium} ${Metrics.margins.larger};
  z-index: 6;
  position: absolute;
  top: 46px;
  right: 0;
  min-width: 150px;
  border: ${Metrics.borders.default};
  color: ${Colors.black};
  background-color: ${Colors.white};

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: block;
    padding: ${Metrics.margins.tiny} ${Metrics.margins.base};
    position: static;
    border: none;
  }
`

class DropdownLinkContainer extends Component {
  render () {
    const { link, toggleDropdown, open, key, avatar, sublinks } = this.props
    const location = window.location.pathname
    let isActive = false
    let linkFunction = null

    if (link) {
      isActive = location.indexOf(link.id || link.label.toLowerCase()) !== -1
      linkFunction = sublinks ? () => toggleDropdown(link.label) : link.onClick
    }

    return (
      <Container key={key}>
        <LinkComponent>
          {avatar || (
            <CustomLink
              active={isActive}
              key={`link-${link.label}`}
              activeClassName='active'
              onClick={linkFunction}>
              {link.label}
            </CustomLink>
          )}
        </LinkComponent>

        {sublinks && (
          <DropdownBox visible={open}>
            <CustomMenuPointer />
            {sublinks.map((sublink, index) => {
              let isSubLinkActive =
                isActive && location.indexOf(sublink.id) !== -1
              return (
                <CustomLink
                  subLink
                  active={isSubLinkActive}
                  key={`sublink-${sublink.label}`}
                  onClick={sublink.onClick}
                  activeClassName='active'>
                  {sublink.label}
                </CustomLink>
              )
            })}
          </DropdownBox>
        )}
      </Container>
    )
  }
}

DropdownLinkContainer.propTypes = {
  link: PropTypes.object,
  toggleDropdown: PropTypes.func,
  open: PropTypes.bool,
  key: PropTypes.string,
  avatar: PropTypes.node,
  sublinks: PropTypes.array,
  name: PropTypes.string
}

export default DropdownLinkContainer



// WEBPACK FOOTER //
// ./src/components/DropdownLinkContainer/index.js